import constant from '../../constant';
import request from '../../../utils/request';
import { GET_VIDEO_INFO, GET_VIDEO_COLLECTION } from '../../../urls'
import { showTip } from '../../../utils'

const getVideoInfo = (params = {}) => {
  return async (dispatch) => {
    try {
      const sDocId = params.sDocId
      if (sDocId) {
        if (window._configs.videoContent && window._configs.videoContent.vid) {
          dispatch(getVideoInfoSuccess(window._configs.videoContent))
          return window._configs.videoContent
        }

        const res = await request.get(GET_VIDEO_INFO, {
          docId: sDocId
        })

        if (res.code === 0) {
          dispatch(getVideoInfoSuccess(res.data))
        }
      } else {
        showTip('缺少必要参数 sDocId')
      }

    } catch (error) {
      console.log('getVideoInfo error',error)
      showTip(error.msg || '服务异常，请稍后再试')
    }
  }
}


const getVideoInfoSuccess = (videoInfo) => {
  return {
    type: constant.VIDEO.GET_VIDEO_INFO,
    videoInfo
  }
}

/**
 * @desc 获取视频集合
 *
 * @param {*} [params={}]
 * @returns
 */
const getVideoCollection = (params = {}, callback) => {
  return async (dispatch) => {
    try {
      const { vid, subjectId, mediaId, type } = params

      const res = await request.get(GET_VIDEO_COLLECTION, {
        vid,
        subjectId,
        mediaId,
        type
      })

      if (res.code === 0) {
        dispatch(getVideoCollectionSuccess(res.data));

        const collections = res.data && res.data.collections || [];
        const docIdArr = collections.map(item => item.cid || '').filter(item => !!item);
        callback && callback(docIdArr || []);
      }

    } catch (error) {
      console.log('getVideoInfo error',error)
      showTip(error.msg || '服务异常，请稍后再试')
    }
  }
}

const getVideoCollectionSuccess = (videoCollection) => {
  return {
    type: constant.VIDEO.GET_MINI_VIDEO_COLLECTION,
    videoCollection
  }
}


export default {
  getVideoInfoSuccess,
  getVideoInfo,
  getVideoCollection,
  getVideoCollectionSuccess
}
